<!--底部菜单模块-->

<template>
	<nav class="c_menu">
		<ul>
			<li :class="current == 'index' ? 'cur' : ''">
				<router-link to="/">
					<i class="iconfont homeIcon"></i>
					<span>首页</span>
				</router-link>
			</li>
			<li :class="current == 'rent' ? 'cur' : ''">
				<router-link to="/goodsAll">
					<i class="iconfont goodsIcon"></i>
					<span>租号</span>
				</router-link>
			</li>
			<li :class="current == 'release' ? 'cur' : ''" v-if="!showzhwk">
				<a :href="'https://static.xubei.com/act/download0418/' + download + '?source=h5&channel=' + channel + '&f=' + fChannel + '&userId=' + userId" @click="appLoad">
					<i class="iconfont">&#xe64f;</i>
					<span>APP下载</span>
				</a>
			</li>
			<li :class="current == 'order' ? 'cur' : ''">
				<router-link to="/my_order?orderType=0">
					<i class="iconfont orderIcon"></i>
					<span>订单</span>
				</router-link>
			</li>
			<li :class="current == 'my' ? 'cur' : ''">
				<router-link to="/my">
					<i class="iconfont myIcon"></i>
					<span>我的</span>
				</router-link>
			</li>
		</ul>
	</nav>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
export default {
	data() {
		return {
			source: localStorage.getItem('source') || '',
			channel: this.$store.state.channel,
			userId: '',
			showzhwk: false,
			download: 'downloadH5.html',
			fChannel: ''
		};
	},
	props: ['current'],
	created() {
		this.fChannel = sessionStorage.getItem('newChannel') || '';
	},
	mounted() {
		if (this.$route.query.channel && this.$route.query.channel == 'Android_huodong_h5') {
			this.download = 'downloadH5New.html';
		}
		if (this.userInfo) {
			this.userId = this.userInfo.userid;
		}
		if (
			localStorage.getItem('zhwk') ||
			localStorage.getItem('shq') ||
			window.location.href.indexOf('xubei.org') > -1 ||
			window.location.href.indexOf('zugehao.com') > -1 ||
			window.location.href.indexOf('zuhw.njweisid.cn') > -1 ||
			window.location.href.indexOf('zhw.whysjiaoyu.cn') > -1 ||
			window.location.href.indexOf('zhw.yunijy.com') > -1
		) {
			this.showzhwk = true;
		}
	},
	computed: {
		...mapState(['userInfo'])
	},
	methods: {
		appLoad() {
		}
	}
};
</script>

<style lang="scss" scoped>
@import '../../style/common';

.c_menu {
	border-top: 1px solid rgb(229, 229, 229);
	position: fixed;
	bottom: 0;
	width: 100%;
	height: px2rem(100rem);
	background: $c_ff;

	ul {
		display: flex;
		height: 100%;

		li {
			flex: 1;
			text-align: center;

			> a {
				display: block;
				height: 100%;

				> i {
					@include font(48rem, #666);
					display: inline-block;
					margin-top: px2rem(10rem);
					width: px2rem(48rem);
					height: px2rem(48rem);
				}

				.homeIcon {
					background: url('../../images/menu/home.png') no-repeat center center;
					background-size: px2rem(48rem) px2rem(48rem);
				}

				.goodsIcon {
					background: url('../../images/menu/goods.png') no-repeat center center;
					background-size: px2rem(48rem) px2rem(48rem);
				}

				.orderIcon {
					background: url('../../images/menu/order.png') no-repeat center center;
					background-size: px2rem(48rem) px2rem(48rem);
				}

				.myIcon {
					background: url('../../images/menu/my.png') no-repeat center center;
					background-size: px2rem(48rem) px2rem(48rem);
				}

				> span {
					display: block;
					@include font(24rem, $c_gray);
				}
			}
		}

		li.cur {
			.homeIcon {
				background: url('../../images/menu/home_active.png') no-repeat center center;
				background-size: px2rem(48rem) px2rem(48rem);
			}

			.goodsIcon {
				background: url('../../images/menu/goods_active.png') no-repeat center center;
				background-size: px2rem(48rem) px2rem(48rem);
			}

			.orderIcon {
				background: url('../../images/menu/order_active.png') no-repeat center center;
				background-size: px2rem(48rem) px2rem(48rem);
			}

			.myIcon {
				background: url('../../images/menu/my_active.png') no-repeat center center;
				background-size: px2rem(48rem) px2rem(48rem);
			}

			span {
				color: $c_blue;
			}
		}
	}

	.dd-img {
		width: 0.48rem;
		height: 0.48rem;
		display: block;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/menu/menu.vue